import Utils from './utils';
import Screen from './screen';
import Stats from 'stats.js';
import VectorTools from './vectorTools';
import InputManager from './inputManager';
import AudioManager from './audioManager';
import SceneManager from './sceneManager';
import DisplayVector from './displayVector';
import EntityFactory from './entityFactory';
import FontAsteroids from '../classes/fontAsteroids';
import VectorTextGenerator from '../classes/vectorTextGenerator';




export default class System {
	


	constructor(args) {
		// ---------------------------
		// PixelJam MicroArcade System
		// ---------------------------
		
		// controller / config
		this.controller = new args.controller.default({ system: this });
		let config = this.controller.getConfig();

		// RNG
		Utils.init(config.seed || 'random');

		// debug stuff
		this.debug = args.debug || false;
		if(this.debug) {
			// mr.doob stats
			this.stats = new Stats();
			this.stats.showPanel(1);
			document.body.appendChild(this.stats.dom);
			this.stats.dom.style.top = 'unset';
			this.stats.dom.style.left = 'unset';
			this.stats.dom.style.bottom = '0';
			this.stats.dom.style.left = '0';
			window.system = this;
			// on-screen log readout
			let d = document.createElement('div');
			d.style.position = 'fixed';
			d.style.zIndex = '1000000000';
			d.style.bottom = '0';
			d.style.right = '0';
			d.style.fontSize = '9px';
			d.style.lineHeight = '13px';
			d.style.letterSpacing = '0.05em';
			d.style.padding = '7px 8px';
			d.style.visibility = 'hidden';
			d.style.fontFamily = 'Monaco, Consolas, monospace';
			d.style.textAlign = 'right';
			d.style.pointerEvents = 'none';

			document.body.appendChild(d);
			window.logLines = [];
			window.logElem = d;
			window.log = function(msg, col='#aaaaaa') {
				window.logLines.push({
					msg:msg,
					col:col,
				});
				if(window.logLines.length > 72) {
					window.logLines.shift();
				}
				let str = '';
				for(let l = 0; l < window.logLines.length; l++) {
					if(l == window.logLines.length-1) {
						str += `<span style="color:${window.logLines[l].col}">${window.logLines[l].msg}</span><br>`;
					} else {
						str += `<span style="color:${window.logLines[l].col};opacity:0.666">${window.logLines[l].msg}</span><br>`;
					}
				}
				window.logElem.innerHTML = str;
				window.logElem.style.visibility = 'visible';
			}
		} else {
			window.log = function() { return null } // catch stray logs in production
		}

		// viewport
		this.screen = new Screen({
			system: this,
			elem: args.elem,
			minWidth: config.viewport.minWidth,
			maxWidth: config.viewport.maxWidth,
			minHeight: config.viewport.minHeight,
			maxHeight: config.viewport.maxHeight,
			preScale: config.viewport.preScale || 1,
		});

		// display
		this.display = new DisplayVector({
			system: this,
			elem: args.elem,
			settings: config.display,
		});
		
		// retain the inverse of the initial system framerate so that
		// delta values fed into game objects per-frame can be
		// normalised to 1.0 with a 'normal speed' reference point
		this.interval = 1000 / config.display.maxFPS;
		this.timeNormal = 1 / this.interval;

		// input
		this.inputManager = new InputManager({ system: this });
		
		// content
		this.shapes = args.shapes || {}; // pre-processed SVG shapes
		this.palette = config.palette;
		this.factory = new EntityFactory({
			system: this,
			textGen: new VectorTextGenerator(FontAsteroids),
		});

		// scenes
		this.sceneManager = new SceneManager({
			system: this,
			modules: args.scenes
		});

		// audio
		this.audio = new AudioManager({
			system: this,
			music: args.music,
			sounds: args.sounds,
			impulses: args.impulses,
		});

		// singletons / globals
		window._VECTORS = new VectorTools({ display: this.display }); // bundle of LFOs for vector FX
	}



	init() {
		this.display.init();
		this.inputManager.init();
		this.controller.init();
		this.audio.init(this.start.bind(this)); // callback after audio has preloaded
	}
	
	start() {
		this.then = Date.now();
		this.loop();
	}



	loop() {
		if(this.screen.focused) {
			let now = Date.now();
			let delta = now - this.then;
			this.interval = 1000 / this.display.settings.maxFPS;
			if(delta >= this.interval) {
				// this.then = now - (delta % this.interval);
				this.then = now;
				if(this.debug) this.stats.begin();
				// The desired frame interval based on settings.maxFPS is sent as delta
				// to update methods, rather than the actual recorded frame interval. This
				// helps to lessen periodic 'fencepost' frame jitters and erratic physics
				// behaviour from inconsistent deltas being fed into Matter.js.
				// Changing settings.timewarp will still affect delta the values being fed
				// to game objects for slo-mo effects (and will play havoc with physics).
				// The downside of using 'idealised' deltas like this is that action will
				// simply slow down, old-school style, if frames become too heavy, but
				// this is the more desirable behaviour than frameskipping, IMO...
				let d = this.interval * this.display.settings.timewarp; // idealised delta
				let dn = d * this.timeNormal;
				this.controller.update(d, dn);
				this.sceneManager.update(d, dn);
				// decoupling the render request from the rAF loop with a 1ms timeout
				// appears to deliver a much more consistent framerate when interleaving
				// 60fps on a 120fps display (even when recorded frametimes are ~2ms).
				setTimeout(() => {
					this.display.render(d, dn);
				}, 1);
				this.sceneManager.cleanUp();
				// -----------------------------------------------
				if(this.debug) this.stats.end();
			}
		}
		requestAnimationFrame(this.loop.bind(this));
	}




}